/* eslint-disable max-lines */
/* eslint-disable max-nested-callbacks */
import { onboarding } from 'api';
import { lsSetOnboardingGuid, lsSetOnboarding } from 'helpers/store';
import {
  SET_ONBOARDING_PROPERTY,
  ONBOARDING_LOGIN,
  ONBOARDING_SAVE_DATA,
  ONBOARDING_UPLOAD_DOCUMENT,
  ONBOARDING_LEGAL_CONDITIONS,
  ONBOARDING_APPLIED_CONSENTS
} from 'store/actions/onboarding';

export default {
  [SET_ONBOARDING_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_ONBOARDING_PROPERTY, { field, value }),

  [ONBOARDING_LOGIN]: ({ commit }, { operationGuid, cif, email }) =>
    new Promise((resolve, reject) => {
      onboarding.login({ operationGuid, cif, email }).then(
        resp => {
          const { data } = resp;
          if (data) {
            commit(SET_ONBOARDING_PROPERTY, {
              field: 'documentsRequired',
              value: data.documentsRequired
            });
            lsSetOnboardingGuid(operationGuid);
            lsSetOnboarding(data);
            resolve(data);
          }
        },
        err => {
          const { messageShow } = err.response.data;
          commit(SET_ONBOARDING_PROPERTY, {
            field: 'errorMessage',
            value: {
              messageShow
            }
          });
          reject(err);
        }
      );
    }),
  [ONBOARDING_SAVE_DATA]: ({ commit }, { operationGuid, container, documentsData }) =>
    new Promise((resolve, reject) => {
      onboarding.saveData(operationGuid, container, documentsData).then(
        resp => {
          const { data } = resp;
          if (data) {
            commit(SET_ONBOARDING_PROPERTY, {
              field: 'documentsRequired',
              value: null
            });
            commit(SET_ONBOARDING_PROPERTY, {
              field: 'identity',
              value: {
                email: '',
                cif: ''
              }
            });
            commit(SET_ONBOARDING_PROPERTY, {
              field: 'saveDocuments',
              value: true
            });
            resolve(data);
          }
        },
        err => {
          const { messageShow } = err.response.data;
          commit(SET_ONBOARDING_PROPERTY, {
            field: 'errorMessage',
            value: {
              messageShow
            }
          });
          reject(err);
        }
      );
    }),
  [ONBOARDING_UPLOAD_DOCUMENT]: (params, { container, folder, docType, file }) =>
    new Promise((resolve, reject) => {
      onboarding
        .uploadDocument({ container, folder, docType, file })
        .then(
          ({ data }) => {
            resolve(data);
          },
          err => {
            reject(err);
          }
        )
        .catch();
    }),
  [ONBOARDING_LEGAL_CONDITIONS]: ({ commit }, { step }) =>
    new Promise((resolve, reject) => {
      onboarding.legalConditions(step).then(
        resp => {
          commit(SET_ONBOARDING_PROPERTY, {
            field: 'legalConditions',
            value: resp.data
          });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),
  [ONBOARDING_APPLIED_CONSENTS]: ({ commit }, { operationGuid, consents }) =>
    new Promise((resolve, reject) => {
      if (!consents) resolve();
      onboarding.appliedConsents(operationGuid, consents).then(
        () => {
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    })
};
